import { render } from "./NewNote.vue?vue&type=template&id=b0b27436&scoped=true"
import script from "./NewNote.vue?vue&type=script&lang=js"
export * from "./NewNote.vue?vue&type=script&lang=js"

import "./NewNote.vue?vue&type=style&index=0&id=b0b27436&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b0b27436"]])

export default __exports__